import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import ukCommon from "./locales/uk/common.json";
import enCommon from "./locales/en/common.json";
import ukAbout from "./locales/uk/about.json";
import enAbout from "./locales/en/about.json";
import ukContacts from "./locales/uk/contacts.json";
import enContacts from "./locales/en/contacts.json";
import ukNews from "./locales/uk/news.json";
import enNews from "./locales/en/news.json";
import ukPrivacy from "./locales/uk/privacy.json";
import enPrivacy from "./locales/en/privacy.json";
import ukShipping from "./locales/uk/shipping.json";
import enShipping from "./locales/en/shipping.json";
import ukFavorites from "./locales/uk/favorites.json";
import enFavorites from "./locales/en/favorites.json";
import ukCheckout from "./locales/uk/checkout.json";
import enCheckout from "./locales/en/checkout.json";
import ukCart from "./locales/uk/cart.json";
import enCart from "./locales/en/cart.json";
import ukDelivery from "./locales/uk/delivery.json";
import enDelivery from "./locales/en/delivery.json";
import ukPreset from "./locales/uk/preset.json";
import enPreset from "./locales/en/preset.json";
import ukProduct from "./locales/uk/product.json";
import enProduct from "./locales/en/product.json";
import ukUserMenu from "./locales/uk/userMenu.json";
import enUserMenu from "./locales/en/userMenu.json";
import ukOrders from "./locales/uk/orders.json";
import enOrders from "./locales/en/orders.json";
import ukAccount from "./locales/uk/account.json";
import enAccount from "./locales/en/account.json";
import ukGuest from "./locales/uk/guest.json";
import enGuest from "./locales/en/guest.json";
import ukChat from "./locales/uk/chat.json";
import enChat from "./locales/en/chat.json";
import ukCatalog from "./locales/uk/catalog.json";
import enCatalog from "./locales/en/catalog.json";
import ukComposer from "./locales/uk/composer.json";
import enComposer from "./locales/en/composer.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      uk: {
        common: ukCommon,
        about: ukAbout,
        contacts: ukContacts,
        news: ukNews,
        privacy: ukPrivacy,
        shipping: ukShipping,
        favorites: ukFavorites,
        checkout: ukCheckout,
        cart: ukCart,
        delivery: ukDelivery,
        preset: ukPreset,
        product: ukProduct,
        userMenu: ukUserMenu,
        orders: ukOrders,
        account: ukAccount,
        guest: ukGuest,
        chat: ukChat,
        catalog: ukCatalog,
        composer: ukComposer,
      },
      en: {
        common: enCommon,
        about: enAbout,
        contacts: enContacts,
        news: enNews,
        privacy: enPrivacy,
        shipping: enShipping,
        favorites: enFavorites,
        checkout: enCheckout,
        cart: enCart,
        delivery: enDelivery,
        preset: enPreset,
        product: enProduct,
        userMenu: enUserMenu,
        orders: enOrders,
        account: enAccount,
        guest: enGuest,
        chat: enChat, 
        catalog: enCatalog,
        composer: enComposer,
      },
    },

    fallbackLng: "uk",
    // lng: "uk",
    supportedLngs: ["uk", "en"],

    ns: ["common", "about", "contacts", "news", "privacy", "shipping", "favorites", "checkout", "cart", "delivery", "preset", 
        "product", "userMenu", "orders", "account", "guest", "chat", "catalog", "composer"],
    defaultNS: "common",

    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "site_lang",
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;